import { entityAPI, getPathwayData } from "api/GenericAPI";
import { nodeAPI, edgeAPI } from "api/GenericPathwayAPI";

import {
  Functionality_Base_Backend,
  Functionality_Value_Base_Backend,
} from "api/GenericPathwayInterfaces";

import {
  Discipleship_Pathway_Backend,
  Discipleship_Pathway_Edge_Backend,
  Discipleship_Pathway_Node_Backend,
  DiscipleshipPathwayFlow,
  Person,
} from "api/Community/CommunityInterfaces";

import { transformDiscipleshipPathwayToFlow } from "api/Community/CommunityTransformations";
import { apiClient } from "api/APIClient";
import { Discipleship_Stage } from "api/Community/CommunityInterfaces";



export const getDiscipleshipPathwayData = async (
): Promise<DiscipleshipPathwayFlow> => {
  return getPathwayData<
    Discipleship_Pathway_Backend,
    DiscipleshipPathwayFlow
  >(`/community/discipleship_pathway/`, transformDiscipleshipPathwayToFlow);
};

export const discipleshipStagesAPI = entityAPI<
  Discipleship_Stage
>("community", "discipleship_stage");

export const functionalityAPI = entityAPI<
  Functionality_Base_Backend
>("community", "discipleship/functionalities");

export const functionalityValuesAPI = entityAPI<
  Functionality_Value_Base_Backend
>("community", "discipleship/functionality_values");
/**
 * ============================================================
 * 🔹 Generic Node & Edge APIs (reusable CRUD)
 * ============================================================
 */

export const discipleshipNodeAPI = nodeAPI<Discipleship_Pathway_Node_Backend>("community/discipleship");
export const discipleshipEdgeAPI = edgeAPI<Discipleship_Pathway_Edge_Backend>("community/discipleship");



// ===================================================
// 🔹 People Management
// ===================================================

/** Get all people within a node */
export const getNodePeople = async (nodeId: number): Promise<Person[]> => {
  const { data } = await apiClient.get<Person[]>(
    `/community/discipleship/nodes/${nodeId}/people/`
  );
  return data;
};


/** Move selected people from one node to another */
export const moveItemsBetweenNodes = async (params: {
  node_id?: number;
  item_field_name: string;
  selected_items: any[];
  handle_name: string;
  direction: "forward" | "backward";
  interaction_id?: number;
  interaction_type?: string;
}): Promise<any> => {
  const { data } = await apiClient.post(
    `/community/discipleship/move_people_between_nodes/`,
    params
  );
  return data;
};